import { SVG, SVGProps } from './svg'

export function IconCandleBarHeikinAshi(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 30 30">
      <path d="M14 5h1v5h3v14h-7V10h3V5Zm3 6h-5v12h5V11Z" />
    </SVG>
  )
}
